module.exports = __webpack_public_path__ + "static/media/hu-about.8f9327ad.jpg";